import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import {
  getHeaderBannerOffset,
  getIsHeaderBannerHidden,
} from 'src/store/headerBanner/selectors';

import YandexMapsExplore from './YandexMapsExplore';
import {
  getActiveHotel,
  isMapView,
  hotelInfoForPopupSelector,
  isExpandableMapSelector,
  getHotelsWithExtraInfo,
} from '../../../domain/state/map/selectors';
import { resetPopupData, toggleMap } from '../../../domain/state/map/actions';

const mapStateToProps = (state) => ({
  activeHotel: getActiveHotel(state),
  hotelsList: getHotelsWithExtraInfo(state),
  isMobile: getIsMobile(state),
  isExpanded: isMapView(state),
  isExpandable: isExpandableMapSelector(state),
  hotelInfoForPopup: hotelInfoForPopupSelector(state),
  isHeaderBannerHidden: getIsHeaderBannerHidden(state),
  headerBannerOffset: getHeaderBannerOffset(state),
});

const mapDispatchToProps = {
  toggleHandler: toggleMap,
  resetPopupDataHandler: resetPopupData,
};

export default connect(mapStateToProps, mapDispatchToProps)(YandexMapsExplore);
